import { projectSchema, type Project } from '@plane/shared';
import { z } from 'zod';

import { apiRequest } from '@/services/http-client';

/** Só obras publicadas: a API filtra para quem não está autenticado. */
export function fetchProjects(): Promise<Project[]> {
  return apiRequest('/api/v1/projects', z.array(projectSchema));
}
